import React, { useState, useEffect } from 'react';
import { terms_disclaimer_privacy_html } from '../../text_arrays.js';

const TermsModal = ({ onClose, onAgree }) => {
const [termsCheckedInModal, setTermsCheckedInModal] = useState(false);
const [combinedHtml, setCombinedHtml] = useState("");



  useEffect(() => {
    const loadFiles = async () => {
      try {

        const base = process.env.REACT_APP_LANDING_URL || "";
        const files = [
           `${base}/legal/terms`,
           `${base}/legal/disclaimer`,
           `${base}/legal/privacy`,
        ];

        const htmlContents = await Promise.all(
          files.map((url) => fetch(url).then((res) => res.text()))
        );

        const merged = htmlContents.join("<br/><br/><hr/><br/><br/>");
        setCombinedHtml(merged);
      } catch (error) {
        console.error("Error loading HTML files:", error);
      }
    };

    loadFiles();
  }, []);

  return (
    <div className="terms-modal-overlay">
      <div className="terms-modal">
        <h3>Terms of Service, Disclaimer, and Privacy Policy</h3>
        <div className="terms-content">
          <section dangerouslySetInnerHTML={{ __html: combinedHtml }} />
        </div>
        <div className="terms-checkbox">
          <input
            type="checkbox"
            id="agreeTerms"
            checked={termsCheckedInModal}
            onChange={(e) => setTermsCheckedInModal(e.target.checked)}
          />
          <label htmlFor="agreeTerms">
            I have read and agree to the above Terms of Service, Privacy Policy, and Disclaimer.
          </label>
        </div>
        <div className="terms-actions">
          <button
            className="confirm-button"
            onClick={() => {
              if (termsCheckedInModal) {
                onAgree();
              }
            }}
            disabled={!termsCheckedInModal}
          >
            Confirm
          </button>
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
